import { Guid } from '@ef-carbon/primitive';
import isGroup from './isGroup';
import Type from './Type';
function groupsGet(selection, groups) {
    if (!groups) {
        throw new TypeError(`The random link group option was 'undefined' when trying to process the '${ selection }' group`);
    }
    const group = groups.get(selection);
    if (!group) {
        const keys = Array.from(groups.keys()).map(k => `'${ k }'`).join(', ');
        throw new RangeError(`Failed to find the '${ selection }' group in the provided groups (${ keys })`);
    }
    return group;
}
export class LinkRandom {
    constructor({
        ids: selection,
        groups,
        redirect
    }) {
        this.type = Type.Random;
        const ids = !isGroup(selection) ? selection : groupsGet(selection, groups);
        this.ids = Array.from(ids, id => new Guid(id));
        this.redirect = redirect ? new Guid(redirect) : undefined;
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.writable = false;
        descriptors.type.configurable = false;
        descriptors.ids.configurable = false;
        descriptors.redirect.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export {
    LinkRandom as Random
};
export const klass = LinkRandom;
export default LinkRandom;    //# sourceMappingURL=Random.js.map
